import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetTaskItemSubtasksDto, queryKeys, useAccessToken } from "src/http";

const useGetTaskItemSubtasksRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTaskItemSubtasksRequest({
    queryKey,
  }: QueryFunctionContext<
    ReturnType<typeof queryKeys.taskItems.getTaskItemSubtasks>
  >): Promise<GetTaskItemSubtasksDto> {
    const accessToken = await getAccessToken();
    const [{ taskItemGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/task-items/${taskItemGuid}/subtasks`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTaskItemSubtasksRequest };
};

const useGetTaskItemSubtasks = (taskItemGuid: string) => {
  const { getTaskItemSubtasksRequest } = useGetTaskItemSubtasksRequest();

  return useQuery({
    queryKey: queryKeys.taskItems.getTaskItemSubtasks(taskItemGuid),
    queryFn: getTaskItemSubtasksRequest,
  });
};

export { useGetTaskItemSubtasks };
